/**
 * Adapptio Node library.
 *
 * @package lib-nore
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Query boolean parameter to boolean value
 * @param value Value
 * @param defaultValue Default value
 * @returns
 */
export function queryParamToBool(value: any, defaultValue: boolean): boolean {
	let result = defaultValue;

	if (typeof value === "string") {
		result = value.toLowerCase() === "true" ? true : false;
	} else if (typeof value === "boolean") {
		result = value;
	}

	return result;
}
